import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormButton from '../../../../../library/form/components/FormActionButton2';

const ProdIOOExiViewRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyRequired" }} />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyAllocated" }} />
                </li>
                <li className="uiColumnCenter uiColumn60 uiActionBlock">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                                action={{ actionId: "edit",  
                                paramName: "editBtn",
                                actionParam: {pathKey: "OEXI"}, containerKey: "popup" }}
                                className="" ></FormButton>
                    <FormButton formObject={formObject} rowKey={rowKey}
                            starIcon="clear"
                            onlyIcon={true}
                            tooltip="Delete"
                            starIconClassName="uiColorNegativeAction"
                            action={{ actionId: "del",  
                            paramName: "delBtn",
                            actionParam: {pathKey: "OEXI"}, containerKey: "row" }}
                            className="" ></FormButton>
                </li>
            </ul>
        )
}

export default ProdIOOExiViewRow